import googlePhone from "google-libphonenumber";

export const formatPhone = (phone = '', countryCode = 'CL') => {
  if (!phone) return '';

  const PNF = googlePhone.PhoneNumberFormat;
  const phoneUtil = googlePhone.PhoneNumberUtil.getInstance();
  return phoneUtil.format(phoneUtil.parse(phone, countryCode), PNF.INTERNATIONAL);
}
